export const background = {
  default: 'oklch(0.985104 0 0)',
  subtle: 'oklch(0.970151 0 0)',
}
export const surface = {
  default: 'oklch(1 0 0)',
  raised: 'oklch(1 0 0)',
  sunken: 'oklch(0.970151 0 0)',
}
export const text = {
  default: 'oklch(0.175228 0.006346 236.981786)',
  muted: 'oklch(0.426427 0.011202 232.617199)',
  subtle: 'oklch(0.645222 0.009348 225.150438)',
  inverse: 'oklch(1 0 0)',
  link: 'oklch(0.289999 0.117296 259.841938)',
}
export const border = {
  default: 'oklch(0.901624 0.003538 219.535738)',
  subtle: 'oklch(0.94007 0 0)',
  strong: 'oklch(0.645222 0.009348 225.150438)',
}
export const action = {
  default: 'oklch(0.289999 0.117296 259.841938)',
  hover: 'oklch(0.190403 0.080719 260.682766)',
  subtle: 'oklch(0.981046 0.012805 221.42319)',
}
export const success = {
  surface: 'oklch(0.97135 0.019006 140.501237)',
  text: 'oklch(0.40526 0.136911 142.712023)',
  border: 'oklch(0.775209 0.103098 142.532525)',
  solid: 'oklch(0.549041 0.184944 142.800761)',
}
export const warning = {
  surface: 'oklch(0.971893 0.01526 48.562489)',
  text: 'oklch(0.431173 0.130695 40.89405)',
  border: 'oklch(0.791422 0.092884 44.093664)',
  solid: 'oklch(0.58333 0.169705 43.997259)',
}
export const danger = {
  surface: 'oklch(0.966669 0.016317 22.079707)',
  text: 'oklch(0.374388 0.145685 19.336218)',
  border: 'oklch(0.75077 0.106785 18.43901)',
  solid: 'oklch(0.501996 0.192725 18.079135)',
}
export const info = {
  surface: 'oklch(0.947933 0.013249 262.378766)',
  text: 'oklch(0.331327 0.095363 262.195822)',
  border: 'oklch(0.676764 0.068234 261.470834)',
  solid: 'oklch(0.450622 0.123283 262.351496)',
}
